import { get, post } from "../util/crmAxios";
import { getBasicUrls } from '../util/config';

const newAgentManage = getBasicUrls().newAgentManage;
const schoolm = getBasicUrls().schoolm;

/**
 * 跨主体督学额度相关API
 */

// 查询跨主体督学额度列表
export const queryCrossEntitySupervisionQuota = (params) => 
  post(newAgentManage + "school/manage/riskControl/pageLimitList", params);

// 导出跨主体督学额度
export const exportCrossEntitySupervisionQuota = (params) => 
  post(newAgentManage + "manage/riskControl/exportLimitList", params);

// 获取经销商组织架构树
export const getDealerOrganizationTree = (params) => 
  get(newAgentManage + "manage/supervision/getDealerOrganizationTree", params);

// 获取跨主体督学规则配置
export const getCrossEntitySupervisionRules = (params) => 
  get(newAgentManage + "manage/supervision/getCrossEntitySupervisionRules", params);

// 验证学员账号
export const validateStudentAccount = (params) => 
  post(newAgentManage + "manage/supervision/validateStudentAccount", params);

// 提交跨主体督学申请
export const submitCrossEntitySupervisionApplication = (params) => 
  post(schoolm + "manage/supervision/submitApplication", params);

// 审核跨主体督学申请
export const auditCrossEntitySupervisionApplication = (params) => 
  post(newAgentManage + "manage/supervision/auditApplication", params);

// 查询跨主体督学申请列表
export const queryCrossEntitySupervisionApplications = (params) => 
  post(newAgentManage + "school/manage/riskControl/pageDuxueApplyList", params);

// 获取跨主体督学申请详情
export const getCrossEntitySupervisionApplicationDetail = (params) => 
  get(newAgentManage + "manage/supervision/getApplicationDetail", params);

// 导出跨主体督学申请
export const exportCrossEntitySupervisionApplications = (params) => 
  post(newAgentManage + "manage/supervision/exportApplications", params);

/**
 * 经销商系统 - servicepoint 模块
 */

// 学员转校操作前校验
export const checkStudentTransfer = (params) =>
  post(schoolm + "servicepoint/checkStudentTransfer", params);

// 查询账号信息（按账号）
export const queryAccountInfoServicepoint = (params) =>
  post(newAgentManage + "servicepoint/queryAccountInfo", params);

// 跨主体督学申请账号校验
export const checkDuxueApplyAccountInfo = (params) =>
  post(schoolm + "servicepoint/checkDuxueApplyAccountInfo", params);

// 跨主体督学申请前校验
export const checkDuxueApply = (params) =>
  get(schoolm + "servicepoint/checkDuxueApply", params);

// 提交跨主体督学申请
export const submitDuxueApply = (params) =>
  post(schoolm + "servicepoint/submitDuxueApply", params);
